import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import { formatPhase4DateTime } from '../utils/phase4Flow';

const OperationalWindowScreen = ({
  literals,
  pendingUntil = '',
  onRefresh,
  isRefreshing = false,
}) => (
  <div className='full-screen-container digital-loan-preoffer'>
    <div className='screen-content digital-loan-preoffer__scroll'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <p className='digital-loan-phase2__body mb-4'>{literals.body}</p>
      {pendingUntil && (
        <div className='digital-loan-summary-block'>
          <div className='digital-loan-summary-block__row'>
            <span className='digital-loan-summary-block__label'>
              {literals.pendingLabel}
            </span>
            <strong>{formatPhase4DateTime(pendingUntil)}</strong>
          </div>
        </div>
      )}
    </div>
    <div className='screen-actions'>
      <Button
        text={literals.refresh}
        type='secondary'
        loading={isRefreshing}
        disabled={isRefreshing}
        onClick={onRefresh}
      />
    </div>
  </div>
);

OperationalWindowScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  pendingUntil: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  isRefreshing: PropTypes.bool,
};

export default OperationalWindowScreen;
